var hiddenInput = '_16btwim0';
var optionRoot = '_16btwim1';

export { hiddenInput, optionRoot };
//# sourceMappingURL=radio-like-primitive.css.js.map
